document.addEventListener("DOMContentLoaded", () => {
  const TABLET_SCREEN = 768
  const sectionCommitments = document.querySelectorAll('.hn-commitments')
  if (sectionCommitments.length > 0) {
    sectionCommitments.forEach(section => {
      const sectionCommitment = new Swiper(section.querySelector('.swiper'), {
        loop: false,
        spaceBetween: 0,
        slidesPerView: 'auto',
        navigation: {
          nextEl: section?.querySelector('.swiper-button-next'),
          prevEl: section?.querySelector('.swiper-button-prev'),
        },
        pagination: {
          el: section?.querySelector('.swiper-pagination'),
        },
        direction: 'vertical',
        speed: 1000,
        mousewheel: {
          releaseOnEdges: true,
        }
      })
    })
  }

  // Handle set height swiper
  window.addEventListener('resize', handleSetHeighSwiper);

  function handleSetHeighSwiper() {
    if (window.innerWidth >= TABLET_SCREEN) {
      document.querySelector('.hn-commitments__texts .swiper').style.height = document.querySelector('.hn-commitments--right').offsetHeight + 'px'
    }
  }
  handleSetHeighSwiper()
})
